export const environment = {
  production: false,
  identityUrl: 'https://identity-v2-dev.nside.io',
  withCredentials: true,
  angularAppUrl: 'https://lockdown-management-dev.nside.io',
  apiBaseUrl: 'https://v3-api-dev.nside.io',
  mapsApiKey: 'AIzaSyB0xPSuEV1ebWHm-JilyOB7og__PrUN9lo',
  nSidePlatformUrl: 'https://dev.nside.io'
};
